import { Card } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';

export function NewsSection() {
  return (
    <Card className="p-6">
      <h3 className="text-xl font-bold mb-4">إدارة الأخبار</h3>
      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          قسم إدارة الأخبار قيد التطوير. سيتم إضافة الوظائف قريباً.
        </AlertDescription>
      </Alert>
    </Card>
  );
}

